/* eslint-disable import/no-unresolved */
import {
  KlevuConfig,
  KlevuFetch,
  kmcRecommendation,
} from 'https://cdn.skypack.dev/-/@klevu/core@v5.2.3-HNRf1HrJ9AqvnoHcX5mg/dist=es2019,mode=imports,min/optimized/@klevu/core.js'
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.4.1-2bW5h7N5TLEKpP3hb61d/mode=imports,min/optimized/keen-slider.js' // https://keen-slider.io/docs

KlevuConfig.init({
  apiKey: `${window.theme.klevu.apiKey}`,
  url: `https://${window.theme.klevu.url}/cs/v2/search`,
})

class ProductCarousel extends window.BAO.CarouselElement {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.initialiseCarousel()

    if (!this.config.klevuId) return
    this.fetchKMCRecommendations()
  }

  get config () {
    return {
      klevuId: this.dataset.klevuId ?? null,
      currentVariant: this.dataset.currentVariant ?? null,
      maxResults: this.dataset.maxResults
        ? parseInt(this.dataset.maxResults)
        : null,
    }
  }

  async fetchKMCRecommendations () {
    const { klevuId, currentVariant, maxResults } = this.config

    const res = await KlevuFetch(
      kmcRecommendation(
        klevuId,
        { currentProductId: currentVariant },
        ...(maxResults
          ? [{
              klevuModifierId: "limitProducts",
              modifyAfter: (queries) => {
                for (const q of queries) {
                  if (!q.settings) q.settings = {}
                  q.settings.limit = maxResults || 10
                }
                return queries
              }
            }]
          : []),
      ),
    )

    const records = res.apiResponse.queryResults?.[0]?.records ?? []
    const productCardHTML = await this.getAllProductCardHTML(records)

    this.els.slides.element.innerHTML = productCardHTML
    this.reinitCarousel()
  }

  async getAllProductCardHTML (records) {
    const productCardHTML = await Promise.all(
      records.map(
        async (product, index) => await this.getProductCardHTML(product, index),
      ),
    )
    return productCardHTML.filter(Boolean).join('')
  }

  async getProductCardHTML (product, index) {
    const productUrl = product.url.replace(
      '/products/',
      `${window.Shopify.routes.root}products/`,
    )

    return window.BAO.sectionRenderer
      .fetchSingle('klevu-product-carousel-item', `${productUrl}`)
      .then(res => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('.prd-Carousel_Slide')
        return myself ? myself.outerHTML : null
      })
      .catch(() => null)
  }

  reinitCarousel () {
    if (this.carousel) {
      this.carousel.destroy()
      this.carousel = this.initialiseCarousel()
    }
    super.reinitialise()
  }

  initialiseCarousel () {
    if (!this.els?.slides?.exists || !this.els?.slide?.exists) return
    return new KeenSlider(this.els.slides.element, {
      selector: this.els.slide.selector,
      drag: true,
      loop: false,
      mode: 'snap',
      rubberband: false,
      slides: {
        origin: 'auto',
        perView: 2,
        spacing: 2,
      },
      breakpoints: {
        '(min-width: 768px)': {
          slides: {
            perView: 3,
            spacing: 15,
          },
        },
        '(min-width: 1201px)': {
          slides: {
            perView: 4,
            spacing: 15,
          },
        },
      },
    })
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}